module.exports = __webpack_public_path__ + "media/images/icon_x_circle-60561430.svg";